export enum FaqSection {
    General = 'General',
    Billing = 'Billing',
    Licensing = 'Licensing',
    Account = 'Account',
}

export interface QuestionAnswer {
    section: FaqSection;
    question: string;
    answer: string;
}

export const QUESTION_AND_ANSWER: QuestionAnswer[] = [
    {
        // General section
        section: FaqSection.General,
        question: "What is icon.shop?",
        answer: "icon.shop is a massive, premium collection of professionally designed icons for any project. " +
            "We offer various styles and formats to fit your needs, from web applications to marketing materials.",
    },
    {
        section: FaqSection.General,
        question: "What formats are the icons available in?",
        answer: "Our icons are available in SVG, PNG, and as a web font. " +
            "This ensures you have the flexibility to use them in any digital project, maintaining high quality at any size.",
    },
    {
        // Billing section
        section: FaqSection.Billing,
        question: "How does the subscription work?",
        answer: "Our subscription gives you unlimited access to our entire icon library for a flat monthly or yearly fee." +
            " You can download and use as many icons as you need for your projects as long as your subscription is active.",
    },
    {
        section: FaqSection.Billing,
        question: "Can I cancel my subscription at any time?",
        answer: "Yes, you can cancel your subscription at any time from your account dashboard. " +
            "You will retain access to the icons until the end of your current billing period.",
    },
    {
        // Licensing section
        section: FaqSection.Licensing,
        question: "What does the license cover?",
        answer: "Our standard license allows for use in unlimited commercial and personal projects. " +
            "This includes websites, applications, presentations, and printed materials." +
            "You cannot, however, resell or redistribute the icon files themselves.",
    },
    {
        // Account section
        section: FaqSection.Account,
        question: "How do I change my password?",
        answer: "You can change your password from the 'Security' tab in your account settings. " +
            "If you've forgotten your password, you can use the 'Forgot Password' link on the sign-in page to reset it.",
    },
];







